export default "__VITE_ASSET__Bvuj2Fz1__"